<template>
    <div class="update-block">
        <!--<transition-group name="update" v-show="updates.length">-->

        <div class="single-row text-right mb-2" v-if="authenticated">

            <button class="btn btn-success btn-lg"
                    v-on:click="openCreateUpdate"
                    v-show="(fundraiser.teacher_id === user.id) || user.role_id == 1">
                Create
            </button>

            <button class="btn btn-secondary btn-lg"
                    v-show="(fundraiser.teacher_id === user.id) || user.role_id == 1"
                    :disabled="!updates.length"
                    data-toggle="modal" data-target="#editPost"
                    v-on:click="updatePost">
                Edit
            </button>

            <button class="btn btn-danger btn-lg"
                    :disabled="!updates.length"
                    v-show="(fundraiser.teacher_id === user.id) || user.role_id == 1"
                    v-on:click="confirmDelete">
                Delete
            </button>
        </div>

        <hr>

        <el-carousel ref='carousel' v-show="updates.length"
                     :interval="0"
                     :autoplay="false"
                     arrow="never"
                     indicator-position="none"
                     :height="carouselHeight+'px'"
                     @change="changeUpdateListener">

            <el-carousel-item v-for="(update, index) in updates" :key="index" style="height: auto">
                <!--<div v-show="index === currentIndex" v-for="(update, index) in updates" :id="'update'+ index"-->
                <!--v-bind:key="update.id" tabindex="index" class="single-update">-->
                <div class="profile-block mt-2">
                    <div class="details-left">
                        <div class="profile-details">
                            <h5 class="title-5">{{update.title}}</h5>
                            <span>by {{fundraiser.teacher.name}}</span> <br/>
                            <p>{{getPublishDateDifference(update.created_at)}} days ago</p>
                        </div>
                    </div>
                    <!--<slot name="loginSlot" v-if="currentIndex == index"></slot>-->
                    <!--<login-button></login-button>-->
                </div>


                <div class="text-block">
                    <p v-html="update.body" class="paragraph"></p>
                </div>
                <!--</div>-->
            </el-carousel-item>
        </el-carousel>

        <!--</transition-group>-->

        <div class="row mt-2" v-show="!updates.length">
            <div class="col text-center">
                <h2 class="title-2">
                    No Updates yet
                </h2>
            </div>
            <hr>
        </div>

        <br>

        <div class="navigation-block" v-if="updates.length">
            <div class="nav-previous">
                <button :disabled="currentIndex == 0 || !updates.length" class="solid-btn outline icon-left"
                        v-on:click="previous()"><i
                    class="fa fa-chevron-left" aria-hidden="true"></i>Previous update
                </button>
            </div>
            <div class="nav-next">
                <button :disabled="currentIndex == updates.length - 1 || !updates.length" class="solid-btn outline"
                        v-on:click="next()">
                    Next
                    update<i class="fa fa-chevron-right" aria-hidden="true"></i></button>
            </div>
        </div>

        <!--<div class="share-update-outer" v-if="updates.length">-->
            <!--<div class="share-update">-->
                <!--<span>Share this update</span>-->
                <!--<ul>-->
                    <!--<li><a :href="getFacebookLink()" target="_blank" class="solid-btn"><i class="fa fa-facebook"-->
                                                                                          <!--aria-hidden="true"></i>Facebook</a>-->
                    <!--</li>-->
                    <!--<li><a :href="getTwitterLink()" target="_blank" class="solid-btn"><i class="fa fa-twitter"-->
                                                                                         <!--aria-hidden="true"></i>Tweet</a>-->
                    <!--</li>-->
                <!--</ul>-->
            <!--</div>-->
        <!--</div>-->

        <!-- Create Modal -->
        <Modal
            title="Create Update"
            :closable="false"
            :mask-closable="false"
            v-model="showCreateUpdate"
            class-name="vertical-center-modal">
            <div class="card-info">
                <form>
                    <div class="single-row">
                        <h6 class="title-6">Title</h6>
                        <input type="text" class="input-field" :class="{'red-hover': payloadErrors.title}" v-model="post.title" placeholder="Title">
                    </div>
                    <br>
                    <div class="sigle-row">
                        <h6 class="title-6">Body</h6>
                        <wysiwyg v-model="post.body"
                                 class="wysiwyg"
                                 :class="{'red-hover': payloadErrors.body}"
                                 :options='{
                                    hideModules: { "code": true, "table":true },
                                    maxHeight: "500px",
                                    forcePlainTextOnPaste: true,
                                    image: { uploadURL: getUploadUrl}
                                 }'/>
                    </div>
                </form>
            </div>
            <div slot="footer">
                <div class="single-row text-right">
                    <button class="solid-btn outline"
                            @click="showCreateUpdate=false"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        Cancel
                    </button>
                    <button class="solid-btn"
                            @click.prevent="createOrUpdatePost"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        Create
                    </button>
                </div>
            </div>
        </Modal>

        <!-- Edit Modal -->
        <Modal
            title="Create Update"
            :closable="false"
            :mask-closable="false"
            v-model="showEditUpdate"
            class-name="vertical-center-modal">
            <div class="info-card">
                <form action=""></form>
                <div class="sigle-row">
                    <h6 class="title-6">Title</h6>
                    <input type="text" class="input-field" :class="{'red-hover': payloadErrors.title}" v-model="post.title" placeholder="Title">
                </div>
                <br>
                <div class="single-row">
                    <h6 class="title-6">Body</h6>
                    <wysiwyg v-model="post.body"
                             class="wysiwyg"
                             :class="{'red-hover': payloadErrors.body}"
                             :options='{
                                hideModules: { "code": true, "table": true},
                                maxHeight: "500px",
                                forcePlainTextOnPaste: true,
                                image: { uploadURL: getUploadUrl}
                             }'/>
                </div>
            </div>
            <div slot="footer">
                <div class="single-row text-right">
                    <button class="solid-btn outline"
                            @click="showEditUpdate=false"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        Cancel
                    </button>
                    <button class="solid-btn"
                            @click.prevent="createOrUpdatePost"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        Save
                    </button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        created() {

            this.routes = window.App.globalData.routes;

            kinfEvents.$on('FundraiserUpdate:tabUpdateOpen', ev => {
                if (this.currentPostRoute === undefined && !!this.updates.length) {
                    this.changeUpdateListener(!!this.currentIndex ? this.currentIndex : 0);
                }


            });

            this.updates = JSON.parse(JSON.stringify(this.updatesInit))
        },
        mounted() {
            let vm = this;
            if (this.currentPostRoute !== undefined) {
                this.goToRoutePost(this.currentPostRoute.slug);
            }
            if (this.updatesInit.length) {
                this.interval = setInterval(() => {
                    vm.carouselHeight = vm.$refs.carousel.$children[vm.currentIndex].$el.clientHeight;
                }, 20);
            }

        },
        props: {
            authenticated: {
                required: true,
                type: Boolean,
                default: false
            },
            fundraiser: {
                required: true,
                type: Object,
                default() {
                    return {
                        teacher: {
                            user_id: -1
                        }
                    }
                }
            },
            updatesInit: {
                required: true,
                type: Array,
                default() {
                    return [];
                }
            },
            user: {
                required: true,
                default() {
                    return {
                        id: -1
                    }
                }
            },
            currentPostRoute: {
                required: false,
            },
            currentTab: {
                required: false,
            }
        },
        data() {
            return {
                interval: null,
                currentIndex: null,
                post: {
                    title: '',
                    body: ''
                },
                updates: [],
                routes: {},
                showCreateUpdate: false,
                showEditUpdate: false,
                carouselHeight: '300px',
                validating: false,
            }
        },
        computed:{
            payloadErrors(){
                return {
                    title: this.validating && this.post.title.trim() === "",
                    body: this.validating && this.post.body.trim() === "",
                };
            }
        },
        watch: {
            currentIndex() {
                if (this.$refs.carousel !== undefined) {
                    setTimeout(() => {
                        this.carouselHeight = this.$refs.carousel.$children[this.currentIndex].$el.clientHeight;
                    }, 20);
                } else {
                    setTimeout(() => {
                        this.carouselHeight = document.getElementsByClassName('is-active')[0].clientHeight;
                    }, 20);
                }
            },
            currentTab(newval){
                if(newval == 'updates'){
                    this.changeUpdateListener(!!this.currentIndex ? this.currentIndex : 0);
                }
            }
        },
        methods: {
            next() {
                this.$refs.carousel.next();
                clearInterval(this.interval);
            },
            previous() {
                this.$refs.carousel.prev();
                clearInterval(this.interval);
            },
            goToRoutePost(slug) {
               //console.log('go to ' + slug);
                if (this.updates.length) {
                    this.updates.forEach((val, idx) => {
                        if (val.slug === slug) {
                           //console.log('initialpost', idx, val);
                            setTimeout(() => {
                                this.$refs.carousel.setActiveItem(idx);
                                this.changeUpdateListener(0, null);
                            }, 100);
                        }
                    });
                }
            },
            changeUpdateListener(newPos, oldPos) {
                if (newPos !== undefined) {
                    this.currentIndex = newPos;
                   //console.log(this.currentTab,this.currentIndex);
                    if (this.currentTab === 'updates') {
                        let newPath = '/fundraiser/' + this.fundraiser.slug + '/updates/' + this.updates[this.currentIndex].slug;
                       //console.log(newPath);
                        window.history.pushState(null, '', newPath);
                    }
                    // setTimeout(()=>{
                    //     this.carouselHeight = this.$refs.carousel.$children[this.$refs.carousel.activeIndex].$el.clientHeight+'px';
                    // },200);
                }
            },
            getUploadUrl() {
                return this.routes.post_upload_images.replace('FID', this.fundraiser.id);
            },
            getPublishDateDifference(date) {
                const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                let today = new Date();
                let publishDate = new Date(date);
                const utc2 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
                const utc1 = Date.UTC(publishDate.getFullYear(), publishDate.getMonth(), publishDate.getDate());
                return Math.floor((utc2 - utc1) / _MS_PER_DAY);

            },
            confirmDelete() {
                this.$confirm('This will permanently delete the update. Do you want to continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    let deleteRoute = this.routes.post_delete.replace('FID', this.fundraiser.id);
                    deleteRoute = deleteRoute.replace('PID', this.getCurrentUpdate().id);
                    let uri = window.App.globalData.routes.fundraiser_show + "/" + this.fundraiser.slug + '/updates';
                    window.history.pushState(null, '', uri);
                    window.axios.delete(deleteRoute).then((response) => {
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        window.location.reload();
                        this.updatePosts();
                    });


                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            createOrUpdatePost() {
                if(this.validate()){
                    if (this.post.id === undefined) {
                        this.createPost();
                    } else {
                        this.editPost();
                    }
                }
            },
            validate(){
                this.validating = true;
                let hasErrors = false;
                for(let x in this.payloadErrors){
                    if(this.payloadErrors[x]){
                        hasErrors = true;
                    }
                }
                return !hasErrors;
            },
            openCreateUpdate() {
                this.clearPost();
                this.showCreateUpdate = true;
            },
            createPost() {
                let createRoute = this.routes.post_create.replace('FID', this.fundraiser.id);
                window.axios.post(createRoute, this.post).then((response) => {
                    // this.post.id = response.data.data.post.id;
                    this.$forceUpdate();
                    this.$notify({
                        title: 'Success',
                        message: response.data.response.message,
                        type: 'success'
                    });
                    this.updatePosts(true);
                    this.showCreateUpdate = false;
                    // this.focusPost(this.post);
                    // window.$('#createPost').modal('close');
                }).catch(error => {
                    if (error !== undefined) {
                        this.$notify.error({
                            title: 'Error',
                            message: error.response.data.response.message
                        });
                    }
                });
            },
            editPost() {
                let editRoute = this.routes.post_update.replace('FID', this.fundraiser.id);
                editRoute = editRoute.replace('PID', this.post.id);

                window.axios.put(editRoute, this.post).then((response) => {
                    this.post = response.data.data;
                    this.$forceUpdate();
                    this.showCreateUpdate = false;
                    this.showEditUpdate = false;
                    this.$notify({
                        title: 'Success',
                        message: response.data.response.message,
                        type: 'success'
                    });

                    this.updatePosts(true);

                    // this.focusPost(this.post);
                    // window.$('#editPost').modal('close');
                }).catch(error => {
                   //console.log(error);
                    this.$notify.error({
                        title: 'Error',
                        message: error.response.data.response.message
                    });
                });
                ;
            },
            getCurrentUpdate() {
                return this.updates[this.currentIndex];
            },
            clearPost() {
                this.post = {
                    title: '',
                    body: ''
                }
                this.validating = false;
            },
            updatePost() {
                this.clearPost();
                this.validating = false;
                this.post = JSON.parse(JSON.stringify(this.getCurrentUpdate()));
                this.showEditUpdate = true;
            },
            updatePosts(goFirst) {
                let postsRoute = this.routes.get_post.replace('FID', this.fundraiser.id);
                window.axios.get(postsRoute).then((response) => {
                    this.updates = response.data.data;
                    if (goFirst) {
                        this.goToRoutePost(this.updates[0].slug);
                    }
                });

            },
            getTwitterLink() {
                let url = 'https://twitter.com/intent/tweet?';

                if (this.getCurrentUpdate() != undefined && this.getCurrentUpdate().body != null) {
                    url += 'text=Check out the news from ' + this.fundraiser.name + '\'s classroom!';
                    url += '&url=' + this.getShareUrl() + '/updates/' + this.getCurrentUpdate().slug;

                    return url;
                }
            },
            getFacebookLink() {
                let url = 'https://www.facebook.com/sharer/sharer.php?u=';
                if (this.getCurrentUpdate() != undefined && this.getCurrentUpdate().body != null) {
                    url += this.getShareUrl() + '/updates/' + this.getCurrentUpdate().slug;
                }

                return url;
            },
            getShareUrl() {
                return this.routes.app + '/fundraiser/' + this.fundraiser.slug;
            }
        },
    }
</script>
<style lang="less" scoped>
    .mb-2 {
        margin-bottom: 20px;
    }

    .mt-2 {
        margin-top: 20px;
    }

    .vertical-center-modal {
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal {
            top: 0;
        }
    }

    .el-carousel {
        overflow: hidden;
    }

    .wysiwyg {
        border: 2px solid #e2e7ee;
        border-radius: 10px;
        overflow: hidden;
    }
    .wysiwyg.red-hover {
        border: 2px solid #fb202d;
    }

</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/show/FundraiserUpdates.vue